import React from 'react';
import { StatCard } from './StatCard';
import { IPeriodData } from '../model/IPeriodData';
import { IFeeling } from '../model/ICheckin';
import { FEELING_COLORS, SOLID_FEELING_ICONS } from '../components/FeelingIcon';
import { round } from 'lodash';
import { PctChangeIndicator } from './PctChangeIndicator';

export const FeelingStatCard: React.FC<{selectedPeriod: IPeriodData, priorPeriod: IPeriodData}> = ({ selectedPeriod, priorPeriod }) => {

    const getAverage = (period: IPeriodData): number | undefined => {
        const checkinsWithFeeling = period.personal.filter(c => c.feeling !== undefined);
        const total = checkinsWithFeeling.reduce((a, c) => a + c.feeling!, 0);
        return checkinsWithFeeling.length ? total / checkinsWithFeeling.length : undefined;
    };

    const average = getAverage(selectedPeriod);
    const priorAverage = getAverage(priorPeriod);

    // substract from 6 to convert range from 1-5 (5 is very bad) to 5-1 (5 is very good)
    const value = average ? 6 - average : undefined;
    const priorValue = priorAverage ? 6 - priorAverage : undefined;

    const feeling = average ? (Math.round(average) as IFeeling) : IFeeling.Neutral;

    return (
        <StatCard
            data-id="feeling-card"
            Icon={SOLID_FEELING_ICONS[feeling || IFeeling.Neutral]}
            iconColor={FEELING_COLORS[feeling || IFeeling.Neutral]}
            value={value ? String(round(value, 1)) : '—'}
            description="daily feeling"
            changeIndicator={
                <PctChangeIndicator oldValue={priorValue!} newValue={value!} upColor="theme-dark-green" downColor="theme-red" />
            }
        />
    );
};
